import * as angular from "angular";
import {IController} from "angular";

export class Oms3plsSupplierMultiSelectController implements IController {

  suppliers: any;
  options: any;
  isDisabled: any;
  ngRequired: any;
  ngPlaceholder: any;
  onChange: Function;

  private readonly defaultTypes: any;
  private selectOptions: any;

  /* @ngInject */
  constructor(private omsConstants, private $mdSelect) {
    this.defaultTypes = omsConstants.supplierTypes;
  }

  $onInit() {
    this.setOptions();
  }

  $onChanges(changes) {
    if (changes.options && !changes.options.isFirstChange()) {
      this.setOptions()
    }
  }

  reset() {
    this.onChange({suppliers: undefined});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  select() {
    this.onChange({suppliers: this.suppliers});
    this.$mdSelect.hide();
  }

  private setOptions() {
    this.selectOptions = this.options || this.defaultTypes;
  }
}

angular
.module('bringoz.admin.oms')
.component('oms3plsSupplierMultiSelect', {
  bindings: {
    suppliers: '<',
    options: '<?',
    isDisabled: '<?',
    ngRequired: '@?',
    ngPlaceholder: '@?',
    onChange: '&'
  },
  template: require('./oms-3pls-supplier-multi-select.html').default,
  controller: Oms3plsSupplierMultiSelectController
});
